<template>
  <div class="w-full">
    <div class="fm-form-input" :class="cGroupClass">
      <input
        v-model="internalValue"
        type="text"
        :class="cInputClass"
        :placeholder="placeholder"
        @click.stop
        @focusin.stop
      />
      <div
        class="absolute inset-y-0 right-0 flex aspect-square items-center justify-center"
        :class="internalValue ? 'pointer-events-auto cursor-pointer text-red-500 fill-current' : 'pointer-events-none'"
        @click="internalValue = ''"
      >
        <FontAwesomeIcon :icon="['fal', internalValue ? 'xmark' : 'search']" />
      </div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'BaseSearchInput',
  components: { FontAwesomeIcon },
  props: {
    groupClass: {
      type: String,
      required: false,
      default: ''
    },
    modelValue: {
      type: String,
      required: false,
      default: null
    },
    size: {
      type: String,
      required: false,
      default: 'md'
    },
    placeholder: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      searchTerms: ''
    }
  },
  computed: {
    cGroupClass() {
      return this.groupClass
    },
    cInputClass() {
      switch (this.size) {
        case 'extra-small':
          return 'px-2 py-1 gap-1 text-xs'
        case 'small':
        case 'sm':
          return 'px-3 py-1.5'
        case 'large':
          return 'px-5 py-3'
        case 'medium':
        default:
          return 'px-4 py-2'
      }
    },
    internalValue: {
      get() {
        if (this.modelValue) {
          return this.modelValue
        }
        return this.searchTerms
      },
      set(newValue) {
        if (this.modelValue !== null) {
          this.$emit('update:modelValue', newValue)
          this.$emit('type-input', newValue)
        } else {
          this.searchTerms = newValue
          this.$emit('type-input', newValue)
        }
      }
    }
  }
  // watch: {
  //   searchTerms(newValue) {
  //     this.$emit('type-input', newValue)
  //   }
  // },
}
</script>
